import { createSelector } from '@ngrx/store';

import { IDecorationCitation } from '../../models';
import { selectDecoratorsState } from './decorators.selector';

export const getCitation = createSelector(
  selectDecoratorsState,
  (state): IDecorationCitation =>
    state?.citations
      ? {
          ...state.citations,
          references: state.citations.references,
          unnumbered_references: state.citations.unnumbered_references,
          deletedUnnumberedCitationId:
            state.citations.deletedUnnumberedCitationId,
          deletedNumberedCitationId: state.citations.deletedNumberedCitationId,
          selectedNumberedCitationId:
            state.citations.selectedNumberedCitationId,
          referencePrefix: state.citations.referencePrefix,
          unnumberReferencePrefix: state.citations.unnumberReferencePrefix,
          prefix: state.citations.prefix || '',
          sufix: state.citations.sufix || '',
          counterCase: state.citations.counterCase || '',
          orderedReferenceIds: state.citations.orderedReferenceIds,
          isCitationUpdated: state.citations.isCitationUpdated,
          selectedReferenceId: state.citations.selectedReferenceId,
          delFromDocCitationId: state.citations.delFromDocCitationId,
          delFromDocCitationCount: state.citations.delFromDocCitationCount,
          chevronData: state.citations.chevronData,
          fragmentLinks: state.citations.fragmentLinks,
          deletedCitationFromRHP: state.citations.deletedCitationFromRHP,
        }
      : {
          references: [],
          unnumbered_references: [],
          prefix: '',
          sufix: '',
          counterCase: '',
          referencePrefix: 'number',
          unnumberReferencePrefix: 'dash',
          isCitationUpdated: false,
          delFromDocCitationId: null,
          delFromDocCitationCount: null,
          fragmentLinks: {
            incomingLinks: [],
            outgoingLinks: [],
          },
        }
);
